import React, { useContext, useEffect } from "react";
import { ContextHome } from "../../../contextHomeCloude/contextHome";
import { RiCloseCircleLine } from "react-icons/ri";
import "./SingleItemViews.css";
import { paramsQuery } from "../../../helpFunction/helpFunction";
import { Adress } from "../../../helpFunction/urlList";
import { toast } from "react-toastify";
import ReactPlayer from "react-player";

type props = {
	fileName: string;
	setSingleItem: (e: string) => void;
};

export const SingleItemView = ({ setSingleItem, fileName }: props) => {
	useEffect(() => {
		setLoading(true);
	}, []);
	const context = useContext(ContextHome);
	if (!context) return null;
	const { setLoading, path, clearAndReload } = context;

	const pathImg = `${Adress.singleImage}/?${paramsQuery(path, fileName)}`;
	const index = fileName.lastIndexOf(".");
	const fileType = (fileName.slice(index + 1, fileName.length) as string).toLowerCase();

	const closeHandler = async () => {
		setSingleItem("");
		setLoading(false);
		clearAndReload();

		document.querySelector(".disabled")?.classList.remove("disabled");
	};

	const closeLoading = () => {
		setLoading(false);
	};

	if (fileType === "jpg" || fileType === "jpeg" || fileType === "png" || fileType === "bmp" || fileType === "webp") {
		return (
			<>
				<div className="SingleItemView" onClick={closeHandler}>
					<img src={pathImg} alt="Single view " className="SingleItemViewImage" onLoad={closeLoading} />
					<div className="SingleItemViewClose" onClick={closeHandler}>
						<RiCloseCircleLine />
					</div>
				</div>
			</>
		);
	}
	if (fileType === "pdf" || fileType === "txt") {
		return (
			<>
				<div className="SingleItemView" onClick={closeHandler}>
					<iframe about={fileName} title="iFrame" className="iFrame" src={`${Adress.ListReadOne}?${paramsQuery(path, fileName)}`} onLoad={closeLoading}></iframe>

					<div className="SingleItemViewClose" onClick={closeHandler}>
						<RiCloseCircleLine />
					</div>
				</div>
			</>
		);
	}
	if (fileType === "avi" || fileType === "mp4" || fileType === "mov" || fileType === "mpg" || fileType === "mpeg" || fileType === "webm" || fileType === "ogg") {
		return (
			<>
				<div className="SingleItemView" onClick={closeHandler}>
					<ReactPlayer src={`${Adress.test}?${paramsQuery(path, fileName)}`} controls autoPlay className="videoStyle" onPlaying={closeLoading} onPlay={closeLoading} />
					{/* <video controls width={"auto"} height={"auto"} autoPlay className="videoStyle" onLoad={closeLoading}>
							<source src={`${Adress.test}?${paramsQuery(path, fileName)}`} type="video/mp4" />
						</video> */}

					<div className="SingleItemViewClose" onClick={closeHandler}>
						<RiCloseCircleLine />
					</div>
				</div>
			</>
		);
	}

	toast.error("Tego pliku nie moge uruchomić !!!");
	closeHandler();
};
